import Select from 'react-select'
import { useMemo } from 'react'
import moment from 'moment-timezone'

/**
 * Helper to construct timezone option
 */
const constructTimezoneOption = (nowMoment, timezoneName) => {
  const offset = nowMoment.tz(timezoneName).format('Z')
  const offsetText = offset === '+00:00' ? 'UTC' : `UTC ${offset}`
  return {
    label: `(${offsetText}) : ${timezoneName}`,
    value: timezoneName
  }
}

const TimezonePicker = (props) => {
  const { defaultValue, ...rest } = props

  const timezoneOptions = useMemo(() => {
    const nowMoment = moment()

    /**
     * Constructing timezone options
     */
    const timezoneNames = moment.tz.names()
    const allTimezoneOptions = timezoneNames.map((timezone) => {
      return constructTimezoneOption(nowMoment, timezone)
    })

    /**
     * Detecting browser timezone
     */
    const autoDetectedTimezone = moment.tz.guess()
    const autoDetectedTimezoneOptions = [constructTimezoneOption(nowMoment, autoDetectedTimezone)]

    return [
      {
        label: 'Auto Detected',
        options: autoDetectedTimezoneOptions
      },
      {
        label: 'All',
        options: allTimezoneOptions
      }
    ]
  }, [])

  const computedDefaultValue = useMemo(() => {
    if (!defaultValue) {
      return
    }
    if (typeof defaultValue.value === 'undefined') {
      return
    }
    if (typeof defaultValue.label === 'undefined') {
      return constructTimezoneOption(moment(), defaultValue.value)
    }
    return defaultValue
  }, [defaultValue])

  return (
    <Select
      {...rest}
      defaultValue={computedDefaultValue}
      menuPlacement='auto'
      menuPortalTarget={document.body}
      options={timezoneOptions}
      classNamePrefix='react_select'
    />
  )
}

export default TimezonePicker
